import dayjs from "dayjs";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { forwardRef, useEffect, useState } from "react";

import { Holder } from "./Holder";
import DatePicker from "@/components/date-picker-v2";
import useMobile from "@/hooks/useMobile";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import BirthDayCalendar from "@/components/RFCalendar/BirthDayCalendar";

interface Props {
	onChange: (val: string) => void;
	value?: string;
	defaultValue?: string;
	name?: string;
	/** 若传入则覆盖 survey 命名空间下的默认占位文案（如 rapyd 页） */
	placeholder?: string;
}

const RFDatePicker = forwardRef<HTMLElement, Props>((props, ref) => {
	const { t } = useTranslation("survey");
	const router = useRouter();
	const formate = router.locale === "zh-Hans" ? "YYYY-MM-DD" : "MM/DD/YYYY";
	const [visible, setVisible] = useState(false);
	const [date, setDate] = useState<Date>();
	const isMobile = useMobile();
	const holderPlaceholder = props.placeholder ?? t("mm-dd-yyy");

	useEffect(() => {
		if (props.defaultValue) {
			setDate(dayjs(props.defaultValue).toDate());
		}
	}, [props.defaultValue]);

	const renderHolderValue = (_date?: Date) => {
		const _dateStr = dayjs(_date).format(formate);
		if (router.locale === "zh-Hans") {
			return _dateStr.replace("-", "年").replace("-", "月") + "日";
		}
		return _dateStr;
	};

	if (isMobile) {
		return (
			<div ref={ref as any}>
				<Holder placeholder={holderPlaceholder} text={renderHolderValue(date)} onClick={() => setVisible(true)} />

				<DatePicker
					title=""
					visible={visible}
					onClose={() => {
						setVisible(false);
					}}
					value={dayjs(date).toDate()}
					max={dayjs().toDate()}
					min={dayjs("1900-01-01").toDate()}
					onConfirm={(val) => {
						setDate(dayjs(val).toDate());
						props.onChange(dayjs(val).format("YYYY-MM-DD"));
					}}
				/>
			</div>
		);
	}

	return (
		<div ref={ref as any}>
			<Popover open={visible} onOpenChange={(open) => !open && setVisible(false)}>
				<PopoverTrigger asChild>
					<div>
						<Holder placeholder={holderPlaceholder} text={renderHolderValue(date)} onClick={() => setVisible(true)} />
					</div>
				</PopoverTrigger>
				<PopoverContent className="w-auto overflow-hidden p-5 select-none" align="start">
					<BirthDayCalendar
						value={dayjs(date)}
						minDate={dayjs("1900-01-01")}
						maxDate={dayjs()}
						onChange={(val) => {
							setDate(dayjs(val).toDate());
							props.onChange(dayjs(val).format("YYYY-MM-DD"));
							setVisible(false);
						}}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
});

RFDatePicker.displayName = "RFDatePicker";
export default RFDatePicker;
